import {
  Label,
  Modal,
  Search,
  Toast,
} from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";
import { FieldValues, useForm } from "react-hook-form";

import { API_ENDPOINT } from "../../../constants/appConstant";
import { useNetwork } from "../../../hooks/useNetwork";
import {
  CheckboxOptionType,
  DropdownOptionType,
  MasterDataType,
  ToastType,
} from "../../../types";
import { KeyValueType } from "../../../types/common";
import { MultiDropDownController } from "../../controllers";
import { ActionButtonContainer } from "../common/ActionButtonContainer";
import { Heading } from "../common/Heading";

type DataObj = {
  [key: string]: string | number | boolean | null | undefined | KeyValueType;
};

interface AutoApplyNudgeProps {
  preferences: any; // Replace 'any' with the appropriate type if known
  onSubmitHandler: (preferenceData: any) => void;
  showNudge: boolean;
  closeNudge: () => void;
  ctaText?: string;
}

export const AutoApplyNudge: React.FC<AutoApplyNudgeProps> = ({
  preferences,
  onSubmitHandler,
  showNudge,
  closeNudge,
  ctaText = null,
}) => {
  const defaultValues = {
    locations: preferences.locations || [],
    roles: preferences.roles || [],
    skills: preferences.skills || [],
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
  } = useForm<FieldValues>({ defaultValues });

  const [openApop, setOpenApop] = useState(showNudge); // Assuming the modal is open by default
  const [desingationData, setDesingationData] = useState<
    CheckboxOptionType[] | null
  >(null);
  const [locationData, setLocationData] = useState<CheckboxOptionType[] | null>(
    null,
  );
  const [isDropdownOptionLoading, setIsDropdownOptionLoading] = useState(false);
  const [skillsData, setSkillsData] = useState<CheckboxOptionType[] | null>(
    null,
  );

  const { fetchData: fetchAPI } = useNetwork();

  const closeApop = () => {
    closeNudge();
  };

  const areArraysEqualById = (
    firstArray: DataObj[],
    secondArray: KeyValueType[],
  ): boolean => {
    if (firstArray.length !== secondArray.length) {
      return false;
    }

    const firstIds = new Set(firstArray.map((item) => item.id));

    return secondArray.every((item) => firstIds.has(item.id));
  };

  const getAutoApplyLabel = (action: any) => {
    console.log("action", action);
    switch (action) {
      case "renew":
        return "Renew Auto Apply";

      case "enable":
        return "Enable Auto Apply";

      case "update":
        return "Update";

      case "expired":
        return "Re-enable Auto Apply";

      default:
        return "Enable Auto Apply";
    }
  };

  const onSubmit = async (data: any) => {
    const updatedData: Record<string, unknown> = {};

    if (
      !areArraysEqualById(
        data.roles as DataObj[],
        (preferences?.roles as KeyValueType[]) ?? [],
      )
    ) {
      updatedData.roles = data.roles;
    }

    if (
      !areArraysEqualById(
        data.locations as DataObj[],
        (preferences?.locations as KeyValueType[]) ?? [],
      )
    ) {
      updatedData.locations = data.locations;
    }

    if (
      !areArraysEqualById(
        data.skills as DataObj[],
        (preferences?.skills as KeyValueType[]) ?? [],
      )
    ) {
      updatedData.skills = data.skills;
    }
    const payload = {
      action: "enable",
      ...(updatedData ? { preferences: updatedData } : {}),
    };

    onSubmitHandler(payload);
  };
  const skillsDropdownOptionsData = async (skill: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?appName=srp-ui&type=SKILL&limit=10&name=${skill}`,
      "GET",
    );

    const masterSkillsData = (res.data as any)?.data as MasterDataType[];

    const updatedSkillsData =
      masterSkillsData && masterSkillsData.length > 0
        ? masterSkillsData.map((skill) => {
            return {
              value: skill.name,
              id: skill.uuid,
              text: skill.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setSkillsData(updatedSkillsData);
  };
  const designationDropdownOptionsHandler = async (desingation: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?appName=srp-ui&type=DESIGNATION&limit=10&name=${desingation}`,
      "GET",
    );

    const masterDesingationData = (res.data as any)?.data as MasterDataType[];

    const updatedDesingationData =
      masterDesingationData && masterDesingationData.length > 0
        ? masterDesingationData.map((desingation) => {
            return {
              value: desingation.name,
              id: desingation.uuid,
              text: desingation.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setDesingationData(updatedDesingationData);
  };
  const locationDropdownOptionsHandler = async (location: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?appName=srp-ui&type=LOCATION&limit=10&name=${location}`,
      "GET",
    );

    const masterLocationData = (res.data as any)?.data as MasterDataType[];

    const updatedLocationData =
      masterLocationData && masterLocationData.length > 0
        ? masterLocationData.map((location) => {
            return {
              value: location.name,
              id: location.uuid,
              text: location.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setLocationData(updatedLocationData);
  };

  return (
    <Modal
      showModal={openApop}
      closeModal={() => closeApop()}
      isMobile={window.innerWidth < 768}
      showCloseButton={window.innerWidth < 768 ? false : true}
      screenAlignment={window.innerWidth < 768 ? "center" : "right"}
      customClass=" l1-apop l1-relative"
      showHandleBar={true}
      // screenAlignment="bottom-sheet"
    >
      <Heading
        headingText="AI Auto Apply Preferences"
        isMobile={window.innerWidth < 768}
        onCloseBtnClickHandler={() => {
          closeApop();
        }}
      />

      <form
        className="l1-relative l1-mb-16 l1-mt-10 l1-flex l1-w-full l1-flex-col l1-gap-4 md:l1-mb-12 md:l1-mt-14 !l1-h-5/6 md:!l1-h-5/6"
        id="autoApplyPreferencesDetailsForm"
        onSubmit={handleSubmit((data: any) => onSubmit(data))}
        noValidate
      >
        {/* {!isExperienced && ( */}
        <Label
          labelText="Preferred Job Title (max 5)"
          isRequired="true"
          className="!l1-text-sm"
        >
          <MultiDropDownController
            name="roles"
            control={control}
            isRequired={true}
            isSearchable={true}
            maxSelect={5}
            options={desingationData ?? []}
            isLoading={isDropdownOptionLoading}
            onSelect={(selected: DropdownOptionType) => {
              clearErrors("roles");
              setValue("roles", selected);
            }}
            onChangeHandler={(inputText: string) => {
              designationDropdownOptionsHandler(inputText);
            }}
            placeholder={
              getValues("roles") && getValues("roles").length >= 5
                ? "Max limit reached"
                : getValues("roles").length > 0
                  ? "Add another"
                  : "Enter or select your preferred job titles"
            }
            errorMessage={errors.roles ? "This field is required" : ""}
            isDisabled={false}
            leftIcon={<Search />}
          />
        </Label>
        <Label
          labelText="Preferred locations (max 5)"
          isRequired={true}
          className="!l1-text-sm"
        >
          <MultiDropDownController
            name="locations"
            control={control}
            isRequired={true}
            isSearchable={true}
            maxSelect={5}
            options={locationData ?? []}
            onSelect={(selected: DropdownOptionType) => {
              clearErrors("locations");
              setValue("locations", selected);
            }}
            isLoading={false}
            onChangeHandler={(inputText: string) => {
              locationDropdownOptionsHandler(inputText);
            }}
            placeholder={
              getValues("locations") && getValues("locations").length >= 5
                ? "Max limit reached"
                : getValues("locations").length > 0
                  ? "Add another"
                  : "Enter or select your preferred job locations"
            }
            isDisabled={false}
            errorMessage={errors.locations ? "This field is required" : ""}
            leftIcon={<Search />}
          />
        </Label>
        <Label
          labelText="Skills (max 50)"
          isRequired={true}
          className="!l1-text-sm"
        >
          <MultiDropDownController
            name="skills"
            control={control}
            isRequired={true}
            isSearchable={true}
            maxSelect={50}
            options={skillsData ?? []}
            onSelect={(selected: DropdownOptionType) => {
              clearErrors("skills");
              setValue("skills", selected);
            }}
            isLoading={false}
            onChangeHandler={(inputText: string) => {
              skillsDropdownOptionsData(inputText);
            }}

            placeholder={
              getValues("skills") && getValues("skills").length >= 50
                ? "Max limit reached"
                : getValues("skills").length > 0
                  ? "Add another"
                  : "Enter or select your preferred Skills"
            }
            isDisabled={false}
            errorMessage={errors.skills ? "This field is required" : ""}
            leftIcon={<Search />}
            rawText={true}
          />
        </Label>
        <div className="!l1-absolute l1-bottom-0 l1-h-9 l1-w-full l1-text-sm l1-text-content-primary l1-align-middle !l1-p-2 !l1-bg-[#FFF6E5] flex items-center">
          Note: You can deactivate this feature from "Settings"
        </div>
        <ActionButtonContainer
          primaryBtnLabel={getAutoApplyLabel(ctaText)}
          isLoading={false}
          isAutoApplyCTA={true}
        />
      </form>
    </Modal>
  );
};
